<div class="field">
  <label [for]="controlIdPrefix() + '-direction'">
    {{ "gate_administration.hardware_configuration.direction" | translate }}*
  </label>
  <p-select
    [inputId]="controlIdPrefix() + '-direction'"
    [formControl]="form().controls.direction"
    [options]="directionOptions"
    optionLabel="label"
    optionValue="value"
    appendTo="body"
    class="w-full"
  >
    <ng-template let-option #selectedItem>
      {{ option.label | translate }}
    </ng-template>
    <ng-template let-option #item>
      {{ option.label | translate }}
    </ng-template>
  </p-select>
</div>

<div class="field">
  <label [for]="controlIdPrefix() + '-index'">
    {{ "gate_administration.hardware_configuration.index" | translate }}*
  </label>
  <p-select
    [inputId]="controlIdPrefix() + '-index'"
    [formControl]="form().controls.index"
    [options]="indexOptions()"
    optionLabel="label"
    optionValue="value"
    optionDisabled="disabled"
    appendTo="body"
    class="w-full"
  >
    <ng-template let-option #item>
      <span [class.disabled-option]="option.disabled">{{ option.label }}</span>
    </ng-template>
  </p-select>
</div>

<div class="field">
  <label [for]="controlIdPrefix() + '-operation'">
    {{ "gate_administration.hardware_configuration.operation" | translate }}*
  </label>
  <p-select
    [inputId]="controlIdPrefix() + '-operation'"
    [formControl]="form().controls.operation"
    [options]="operationOptions()"
    optionLabel="label"
    optionValue="value"
    optionDisabled="disabled"
    appendTo="body"
    class="w-full"
  >
    <ng-template let-option #selectedItem>
      {{ option.label | translate }}
    </ng-template>
    <ng-template let-option #item>
      <span [class.disabled-option]="option.disabled">{{ option.label | translate }}</span>
    </ng-template>
  </p-select>
</div>

@if (form().controls.operation.value === "door.customSignal") {
  <div class="field">
    <label [for]="controlIdPrefix() + '-label'">
      {{ "gate_administration.hardware_configuration.label" | translate }}*
    </label>
    <input
      pInputText
      type="text"
      [id]="controlIdPrefix() + '-label'"
      [formControl]="form().controls.label"
      maxlength="255"
      autocomplete="off"
      class="w-full"
    />
  </div>
}
